import "./App.css";
import BgcForm from "./Components/BgcForm";

function App() {
  return (
    <div className="App">
      {/* <BgcFormV2 /> */}
      <BgcForm/>
    </div>
  );
}

export default App;

